import React from "react";

const SvgFyzickaOsoba = props => (
  <svg viewBox="0 0 157 208" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Obecn\xE9 ikony">
        <g data-name="Fyzicka osoba">
          <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h157v208H0z" />
          <path d="M79.64 13.12a40.06 40.06 0 1040.06 40.06 40.06 40.06 0 00-40.06-40.06zM51.26 92.48c-24.08 6.32-41 22.62-41 57.81 0 47.92 138.77 47.92 138.77 0 0-35.17-16.93-51.49-41-57.81a47.92 47.92 0 01-56.74 0z" />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgFyzickaOsoba;
